import { useCallback, useContext, useEffect } from 'react'
import _ from 'lodash'
import { useFormDispatch, useFormSelector } from '../../../redux/formStoreHooks'
import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { UlcerReviewConcept, UlcerReviewItem } from '@fusion-advantage/formlib'
import L3UlcerReview from '../l3/L3UlcerReview'
import { selectForm } from '../../../redux/selectForm'
import { useConceptValidator } from './useConceptValidator'
import { setFormModelUlcerReview } from '../../../redux/formModelSlice'
import L6FormContext from '../l6/L6FormContext'

interface L4UlcerReviewProps {
	xpath?: string
}

const L4UlcerReview = ({xpath}: L4UlcerReviewProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4UlcerReview',
		cid: UlcerReviewConcept.cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Object],
	})
	const ulcerMappingData = useFormSelector(selectForm).ulcerData
	const ulcerData = useFormSelector(state => state.formModel.ulcerReview)
	const dispatch = useFormDispatch()
	const handleChange = useCallback((models: UlcerReviewItem[]) => {
		dispatch(setFormModelUlcerReview(models))
	}, [dispatch])
	const shouldPrint = useCallback((): boolean => {
		return ulcerData.length > 0
	}, [ulcerData])
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	useEffect(() => {
		if(xpath) {
			setXpathValuedDeterminer(xpath, shouldPrint)
			return () => {
				setXpathValuedDeterminer(xpath, false)
			}
		}
	}, [xpath, shouldPrint, setXpathValuedDeterminer])
	if(errorNode) {
		return errorNode
	}
	return (
		<L3UlcerReview 
			models={ulcerData}
			mappings={ulcerMappingData}
			onChange={handleChange}
		/>
	)
}

export default L4UlcerReview